(() => {
  const mount = root => {
    if (root.dataset.journalReady) return;
    root.dataset.journalReady = 'true';
    const body = root.querySelector('[data-journal-body]');
    const rail = root.querySelector('[data-journal-toc]');
    if (!body || !rail) return;
    const headings = [...body.querySelectorAll('h2')];
    const list = rail.querySelector('ol');
    if (headings.length > 1) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${body.id}-part-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link); list.append(item);
      });
      rail.hidden = false;
      if (matchMedia('(max-width: 899px)').matches) rail.querySelector('details').open = false;
    }
    const links = [...list.querySelectorAll('a')];
    let pending = false;
    const update = () => {
      const rect = body.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight * .3 - rect.top) / Math.max(1, rect.height - innerHeight * .6)));
      rail.querySelector('.mm-journal__progress span').style.transform = `scaleX(${progress})`;
      let active = 0;
      headings.forEach((h, i) => { if (h.getBoundingClientRect().top < innerHeight * .35) active = i; });
      links.forEach((link, i) => { if (i === active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
      pending = false;
    };
    addEventListener('scroll', () => { if (!pending) { pending = true; requestAnimationFrame(update); } }, {passive: true});
    addEventListener('resize', update, {passive: true}); update();
    list.addEventListener('click', event => { if (event.target.closest('a') && matchMedia('(max-width: 899px)').matches) rail.querySelector('details').open = false; });
  };
  document.querySelectorAll('[data-journal]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-journal]').forEach(mount));
})();
